module.exports = __webpack_public_path__ + "img/rutify01.a731f615.png";